export const LEAD_SOURCES_PATH = 'api/landlord/lead-sources';
